'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeypadConfig = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backspace = require('./backspace.svg');

var _backspace2 = _interopRequireDefault(_backspace);

var _submit = require('./submit.svg');

var _submit2 = _interopRequireDefault(_submit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeypadConfig = exports.KeypadConfig = function () {

    // Define defaults
    function KeypadConfig() {
        _classCallCheck(this, KeypadConfig);

        this.keypadDefaults = {

            // The array of numbers that makes up the keypad
            numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0], // eslint-disable-line no-magic-numbers

            // By default there is no max length
            // Integer
            maxLength: null,

            // Plug'N'Play button types
            types: ['backspace', 'submit'],

            backspaceTemplate: _backspace2.default,
            submitTemplate: _submit2.default

        };
    }

    _createClass(KeypadConfig, [{
        key: '$get',
        value: function $get() {
            return this.keypadDefaults;
        }

        /**
         * Set a custom backspace button template
         * NOTE: $templateCache is not available yet so we save the template and the controller will
         * handle overwriting the default template
         *
         * @param {String} template
         */

    }, {
        key: 'setBackspaceTemplate',
        value: function setBackspaceTemplate(template) {
            this.keypadDefaults.customBackspaceTemplate = template;
        }

        /**
         * Set a custom submit button template
         * NOTE: $templateCache is not available yet so we save the template and the controller will
         * handle overwriting the default template
         *
         * @param {String} template
         */

    }, {
        key: 'setSubmitTemplate',
        value: function setSubmitTemplate(template) {
            this.keypadDefaults.customSubmitTemplate = template;
        }

        /**
         * Overwrite the max length
         *
         * @param {Integer} length
         */

    }, {
        key: 'setMaxLength',
        value: function setMaxLength(length) {
            this.keypadDefaults.maxLength = parseInt(length, 10);
        }
    }]);

    return KeypadConfig;
}();


/** WEBPACK FOOTER **
 ** ./src/keypad.provider.js
 **/